import './FilterPills.css';

export interface FilterState {
  format: string | null;
  potency: string | null;
  effect: string | null;
  buyable: boolean;
}

interface FilterPillsProps {
  filters: FilterState;
  onToggle: (category: keyof FilterState, value: string) => void;
  onToggleBuyable: () => void;
}

const POTENCY_OPTIONS = [
  { label: '2-3mg', value: '2-3' },
  { label: '5mg', value: '5-5' },
  { label: '10mg', value: '10-10' },
  { label: '10mg+', value: '11-100' },
];

export function FilterPills({ filters, onToggle, onToggleBuyable }: FilterPillsProps) {
  return (
    <div className="filter-pills" role="group" aria-label="Filter by strength">
      <div className="filter-pills__row">
        <button
          type="button"
          className={`filter-pills__pill filter-pills__pill--buy${filters.buyable ? ' filter-pills__pill--active' : ''}`}
          onClick={onToggleBuyable}
          aria-pressed={filters.buyable}
        >
          🛒 Buy Now
        </button>
        {POTENCY_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            className={`filter-pills__pill${filters.potency === opt.value ? ' filter-pills__pill--active' : ''}`}
            onClick={() => onToggle('potency', opt.value)}
            aria-pressed={filters.potency === opt.value}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
